import { api } from "./client";
import type { Wholesaler } from "@/lib/types/inventory";

export function getWholesalers(params?: { pageSize?: number }) {
  return api.get<{
    data: { wholesalers: Wholesaler[] };
    wholesalers?: Wholesaler[];
  }>("/wholesalers", { params });
}

export function createWholesaler(data: { name: string; contactInfo?: string }) {
  return api.post<{ data: { wholesaler: Wholesaler } }>("/wholesalers", data);
}

export function updateWholesaler(
  id: string,
  data: { name: string; contactInfo?: string }
) {
  return api.put<{ data: { wholesaler: Wholesaler } }>(
    `/wholesalers/${id}`,
    data
  );
}

export function deleteWholesaler(id: string) {
  return api.delete(`/wholesalers/${id}`);
}
